import { DraggableModalCore } from './Core'
import { DraggableModalProps } from './interface'
import { DraggableModalStoreProvider } from './Store'

export const DraggableModal = (props: DraggableModalProps) => {
  return (
    <DraggableModalStoreProvider>
      <DraggableModalCore {...props} />
    </DraggableModalStoreProvider>
  )
}
